// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {use_theme} from '../../settings_ctx';
import {img_url} from '../img_url';
import {Nav_menu} from './nav_menu';
import {Nav_user} from './nav_user';
import {use_navbar} from './use_navbar';
import styles from './nav.module.less';
import storage from '/util/storage.js';
import {useLocation} from 'react-router-dom';

const logo_links = {
    '/affiliate_frm': {to: '/pricing/premium?ref=affiliate_frm',
        target: '_blank', rel: 'noopener noreferrer'},
    '/download_ie': {to: null},
};

export const Nav = (props: ReturnType<typeof use_navbar>)=>{
    const {is_scrolled, has_user, is_plus, headlogo, has_ext, is_portal,
        is_client, nomenu, nologin, nav_opt, cp_link, cp_after_login,
        with_cart, no_getstarted, cp_always_icon} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const nav_cls = cn(styles.nav, theme.root, {
        [styles.scrolled]: is_scrolled,
        [styles.transparent]: nav_opt?.transparent,
    });
    const show_nav_menu = is_client && !headlogo && !nomenu;
    // XXX: defined in vpn_config
    // why: there is link to open /faq
    // we have to go back to /vpn_config
    const {pathname, search} = useLocation();
    const global_homepage = is_client ? storage.get('global_homepage') : '';
    const link_props = nav_opt?.logo_to ? {to: nav_opt.logo_to} :
        global_homepage ? {to: global_homepage} :
        logo_links[pathname] || {to: '/'};
    if (link_props && link_props.to=='/vpn_config'
        || search && search.indexOf('logo_disabled')>-1)
    {
        link_props.to = '';
    }
    const menu_visible = !is_portal && pathname=='/' ? is_scrolled : true;
    const logo = nav_opt?.logo || 'hola_logo_letters.svg';
    const img_url_fn = nav_opt?.img_url_fn || img_url;
    const custom_logo = !!nav_opt?.logo;
    return <div className={nav_cls}>
      <div className={cn(theme.container, styles.container)}>
        <Link {...link_props} className={cn(styles.logo,
          custom_logo && styles.auto_height)} data-clickid="nav_logo">
          <img src={img_url_fn(logo)} alt={'Site logo'} className="lazyload"/>
        </Link>
        {show_nav_menu && <Nav_menu is_plus={is_plus}
          visible={menu_visible} has_ext={has_ext}/>}
        {headlogo || nologin ? <div/> : <Nav_user has_user={has_user}
          is_scrolled={is_scrolled} has_ext={has_ext}
          no_getstarted={no_getstarted}
          cp_link={cp_link} cp_after_login={cp_after_login}
          cp_always_icon={cp_always_icon}
          with_cart={with_cart}/>}
      </div>
    </div>;
};
